import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import BusinessDepartmentShowcase from './BusinessDepartmentShowcase';
import './businessfield.css';

const BusinessShoppingmallPage = () => {
  const infraRef = useRef(null);
  const [chainInView, setChainInView] = useState(false);

  useEffect(() => {
    const el = infraRef.current;
    if (!el) return;
    if (typeof window !== 'undefined' && !('IntersectionObserver' in window)) {
      setChainInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setChainInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/business/shoppingmall';
  const title = '쇼핑몰사업부 - 주식회사 가까운물류';
  const desc = '온라인 쇼핑몰 운영 및 관리 서비스를 제공합니다.';

  const cards = [
    { title: '쇼핑몰 운영 및 관리', 
      description: '운영 정책과 채널 관리\n안정적 운영',
      descVariant: 'preline',
    },
    { title: '상품 등록 및 관리', 
      description: '상품/재고 정보 관리\n운영 효율화',
      descVariant: 'preline',
    },
    { title: '고객 서비스', 
      description: '문의/CS 대응\n고객 만족도 향상',
      descVariant: 'preline',
    },
    { title: '마케팅 및 홍보', 
      description: '프로모션 및 콘텐츠 운영\n성장 지원',
      descVariant: 'preline',
    },
  ];

  return (
    <div className="business-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>

      <IntroductionTabs type="business">
        <div tabId="shoppingmall" className="business-content">
          <BusinessDepartmentShowcase
            headline={
              <>
                <span className="hl">쇼핑몰사업부</span>는 온라인 판매 채널 운영을 기반으로
                <br />
                상품/CS/마케팅까지 전 과정을 관리합니다.
              </>
            }
            pill="온라인 운영 전문 조직"
            pillDescription="운영 효율과 고객 경험을 동시에 개선하는 방향으로 프로세스를 구축합니다."
            featureTitle="쇼핑몰사업부의 특성"
            featureEmphasis="운영·상품·CS·마케팅을 유기적으로 연결해, 성과와 고객 만족을 함께 만듭니다."
            featureDescription="데이터 기반 운영과 체계적인 관리로 지속 가능한 성장 모델을 지향합니다."
            centerLabel="쇼핑몰사업부"
            cards={cards}
            layout="cardsRow"
          />

          {/* 운영 인프라 및 지사 구성 */}
          <section className="deptv2-infra" ref={infraRef}>
            <div className="deptv2-infra-inner deptv2-infra--vertical">
              <h3 className="deptv2-infra-title deptv2-infra-title--center">
                <span className="hl">주식회사 가까운물류</span>의 운영 쇼핑몰
              </h3>
              <p className="deptv2-infra-sub deptv2-infra-sub--center">
                아래와 같은 쇼핑몰을 운영하고 있습니다.
              </p>

              <div className={`deptv2-infra-chain deptv2-infra-chain--shoppingmall ${chainInView ? 'is-in-view' : ''}`} aria-label="운영 쇼핑몰">
                <div className="deptv2-chain-node deptv2-chain-node--shopping deptv2-chain-node--naver">네이버<br />스마트스토어</div>
                <div className="deptv2-chain-node deptv2-chain-node--shopping deptv2-chain-node--coupang">쿠팡쇼핑</div>
                <div className="deptv2-chain-node deptv2-chain-node--shopping deptv2-chain-node--toss">토스쇼핑</div>
              </div>

              <div className="deptv2-infra-copy">
                <p className="deptv2-infra-copy-title">
                  <span className="hl">쇼핑몰 운영을 기반으로</span>
                </p>
                <p className="deptv2-infra-copy-desc">
                  쇼핑몰 운영과 빠른 대응이 가능하며,
                  <br />
                  <span className="hl">고객에게</span> 만족스러운 서비스를 제공합니다.
                </p>
              </div>
            </div>
          </section>
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default BusinessShoppingmallPage;
